const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = '/queue-turn';

const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
    let message = fallbackMessage;
    try {
        const data = await response.json();
        message = data?.message || data?.error || fallbackMessage;
    } catch (_) {
        try {
            const text = await response.text();
            message = text || fallbackMessage;
        } catch (_) {}
    }

    console.error(`API Error [${response.status}]: ${message}`);
    throw new Error(message);
};

export const getTurnDetails = async (turnID) => {
    const response = await fetch(`${BASE_URL}${API_URL}/secure/${turnID}`);

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل بيانات الدور");
    }

    return await response.json();
};
